export default {

    noPadding: {
        padding: 0
    },
    noVPadding: {
        paddingTop: 0,
        paddingBottom: 0
    },
    noHPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    paddingTop10: {
        paddingTop: 10
    },
    paddingH5: {
        paddingLeft: 5,
        paddingRight: 5
    },
    paddingH10: {
        paddingLeft: 10,
        paddingRight: 10
    },
    paddingLeft10: {
        paddingLeft: 10
    },
    paddingLeft20: {
        paddingLeft: 20
    }
}